<template>
  <IconMdiMicrosoftOutlook />
</template>
